import styled from 'styled-components';

export const RegistrationPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const RegistrationPageInnerWrapper = styled.div`
  max-width: 840px;
  width: 100%;
`;
